import React, { useContext, useEffect, useState } from "react";

import { window } from "@swa-ui/browser";
import { Icon, Toggle } from "@swa-ui/core";
import { DesignTokensThemeContext } from "@swa-ui/design-tokens";
import { ErrorBoundary } from "@swa-ui/error";

import styles from "./DarkModeToggle.module.scss";

/**
 * DarkModeToggle allows toggling between light and dark themes,
 * and can be displayed by pressing Shift + F6.
 */

export const DarkModeToggle = () => {
  const [isToggleRevealed, setToggleRevealed] = useState(false);
  const { isDarkMode, setIsDarkMode } = useContext(DesignTokensThemeContext) ?? {};

  useEffect(() => {
    window.addEventListener("keyup", toggleDarkModeOnShiftF6); // NOSONAR

    return () => {
      window.removeEventListener("keyup", toggleDarkModeOnShiftF6);
    };
  }, [isToggleRevealed]);

  return (
    <ErrorBoundary fallbackComponent={() => null}>
      {isToggleRevealed && (
        <div className={styles.toggleBar}>
          <div className={styles.toggleLabel}>Dark Mode {`${isDarkMode ? "ON" : "OFF"}`}</div>
          <div className={styles.toggleControls}>{renderToggle()}</div>
        </div>
      )}
    </ErrorBoundary>
  );

  function renderToggle() {
    return (
      <>
        <Icon color="dark-mode-toggle-icon-fg" name="Sun" size="size36" />
        <Toggle
          checked={isDarkMode}
          onChange={() => setIsDarkMode(!isDarkMode)}
          aria-label="Toggle dark mode"
        />
        <Icon color="dark-mode-toggle-icon-fg" name="NextDay" size="size32" />
      </>
    );
  }

  function toggleDarkModeOnShiftF6(event) {
    if (event.key === "F6" && event.shiftKey) {
      setToggleRevealed(!isToggleRevealed);
    }
  }
};
DarkModeToggle.displayName = "DarkModeToggle";
